module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"label":"Få full tilgang","labelShort":"Oppgrader","paymentLabelShort":"Manglende betaling","paymentLabel":"Manglende betaling"},"en":{"label":"Upgrade to unlock","labelShort":"Upgrade","paymentLabelShort":"Missing payments","paymentLabel":"Missing payments"}}')
  delete Component.options._Ctor
}
